import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { IBridgeEvent } from "~app/common/services/event-bridge.service";
import { MapEvents } from "~app/features/planera/events/map-events";
import { IPlaneraTheaterView, PlaneraEvents } from "~app/features/planera/events/planera-events";
import { IArbetsorderAtgarder } from "~app/features/planera/model/IArbetsorderAtgarder";
import { PlaneraKartaEventService } from "~app/features/planera/planera-karta/planera-karta-event.service";
import { ArbetsorderBulkContextMenuComponent } from "../../../arbetsorder-bulk-context-menu/arbetsorder-bulk-context-menu.component";

@Component({
    selector: "rask-planera-search-results-header",
    templateUrl: "./planera-search-results-header.component.html",
    styleUrls: ["./planera-search-results-header.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ArbetsorderBulkContextMenuComponent,
        CheckboxComponent,
        FormsModule
    ]
})
export class PlaneraSearchResultsHeaderComponent implements OnInit, OnDestroy {
    @Input() arbetsorderList: IArbetsorderAtgarder[] = [];

    // Den här propertyn borde lyssna på ett event från (Kanske inte Mediatorn i detta fall?) och sätta denna flagga till true/false beroende på om hela kartan visas eller inte
    mapTheatherModeEnabled = false;
    @Input() selectedArbetsorderList: IArbetsorderAtgarder[] = [];

    // Den här propertyn borde lyssna på ett event från Mediatorn och sätta denna flagga till true/false beroende på om det enbart är valda AO som visas eller inte
    showOnlySelected = false;

    private readonly planeraKartaEventService = inject(PlaneraKartaEventService);
    private readonly planeraKartaEvents: IBridgeEvent[] = [];

    ngOnDestroy(): void {
        this.planeraKartaEventService.unsubscribeMany(this.planeraKartaEvents);
        this.planeraKartaEvents.splice(0);
    }

    ngOnInit(): void {
        this.planeraKartaEvents.push(this.planeraKartaEventService.subscribe(MapEvents.selectMulti, (payload: any) => {
            this.showOnlySelected = payload.selected;
        }));

        this.planeraKartaEvents.push(this.planeraKartaEventService.subscribe<IPlaneraTheaterView>(PlaneraEvents.theaterView, (payload) => {
            this.mapTheatherModeEnabled = payload.theaterViewActive;
        }));
    }

    toggleMapTheaterMode() {
        this.mapTheatherModeEnabled = !this.mapTheatherModeEnabled;
        this.planeraKartaEventService.emit(PlaneraEvents.theaterView, { theaterViewActive: this.mapTheatherModeEnabled });
    }

    toggleShowOnlySelected() {
        this.showOnlySelected = !this.showOnlySelected;

        this.planeraKartaEventService.emit(MapEvents.selectMulti, { selected: this.showOnlySelected });
        this.planeraKartaEventService.emit(MapEvents.showOnlySelected, this.showOnlySelected);
    }
}
